import { useTranslation } from 'react-i18next';
import { useOrderDetails } from 'components/context/order_details';
import { toCurrency } from 'utilities/currency';

const subtitleStrings = (offer) => {
  const { t } = useTranslation();
  const { store } = useOrderDetails();

  const n = offer.number_payment_periods;
  const paymentAmount = offer.payment_amount;
  const finalPaymentAmount = offer.final_payment_amount;

  const paymentAmountString = toCurrency(
    paymentAmount.amount,
    paymentAmount.currency_code,
  );
  const finalPaymentAmountString = toCurrency(
    finalPaymentAmount.amount,
    finalPaymentAmount.currency_code,
  );

  if (store !== 'US') {
    return [
      t('checkout.receipt.label.singlePayment', {
        money: finalPaymentAmountString,
      }),
      t('checkout.receipt.label.nPaymentsOf', {
        money: paymentAmountString,
        n: n - 1,
      }),
    ];
  }

  const separateLines = finalPaymentAmount.amount !== paymentAmount.amount;
  if (separateLines) {
    return [
      t('checkout.receipt.label.nPaymentsOf', {
        money: paymentAmountString,
        n: n - 1,
      }),
      t('checkout.receipt.label.finalPayment', {
        money: finalPaymentAmountString,
      }),
    ];
  }

  return [
    t('checkout.receipt.label.nPaymentsOf', {
      money: paymentAmountString,
      n,
    }),
  ];
};

export { subtitleStrings };
